const awsExports = {
    "IDENTITY_POOL_ID": "us-east-1:bc3840da-9bc6-433d-b44f-6eea70941035",
    "USER_POOL_ID": "us-east-1_ABgZwJLtq",
    "USER_POOL_APP_CLIENT_ID": "125g75na0dc9ngjjo8e1rta8ta",
    "USER_CONTENT_BUCKET": "meeting-notes-634149026265-media",
    "APPSYNC_GRAPHQL_ENDPOINT": "https://25ibuwsesvg43kkiakeigk2vze.appsync-api.us-east-1.amazonaws.com/graphql",
    "API_ENDPOINT": "",
    "AWS_REGION": "us-east-1"
};
export default awsExports;